<template>
  <div class="select-from-dictionary" :style="boxStyle">
    <!-- 单级选择 -->
    <el-select
      v-if="!isMultipuleLevel"
      v-model="selected"
      :value="selected"
      :placeholder="placeholder"
      :size="size"
      :disabled="disabled"
      :multiple="isMultipuleSelect"
      clearable
      :style="cusStyle"
      @change="changeSelect"
    >
      <el-option
        v-for="item in dataList"
        :key="item.code"
        :label="item.dictionaryKey"
        :value="item.code"
      />
    </el-select>
    <!-- 多级选择 -->
    <el-cascader
      v-else
      ref="cascader"
      v-model="selected"
      :options="dataList"
      :props="{
        checkStrictly: true,
        value: 'code',
        label: 'dictionaryKey',
        expandTrigger: 'hover',
      }"
      clearable
      style="width: 100%"
      :placeholder="placeholder"
      :show-all-levels="false"
      @change="changeSelect"
      @expand-change="handleChangeOrgans"
    />
  </div>
</template>
<script>
import { getKeyValues } from "@/utils/index";
import { dataKeyMap } from "@/utils/constant";
export default {
  name: "SelectFromDictionary",
  props: {
    // 样式
    cusStyle: {
      default() {
        return "";
      },
    },
    // 容器样式
    boxStyle: {
      default() {
        return "";
      },
    },
    // 是否多层级
    isMultipuleLevel: {
      default() {
        return false;
      },
    },
    // 是否禁用
    disabled: {
      default() {
        return false;
      },
    },
    // 是否多选
    isMultipuleSelect: {
      default() {
        return false;
      },
    },
    // 尺寸
    size: {
      default() {
        return "";
      },
    },
    // 对应的key值
    code: String,
    // 选中值

    defaultVal: {
      default() {
        return this.isMultipuleSelect ? [] : "";
      },
    },

    placeholder: {
      default() {
        return "请选择";
      },
    },
  },
  data() {
    return {
      selected: this.isMultipuleSelect ? [] : "",
      dataList: [],
      list:[],
    };
  },
  watch: {
    defaultVal(newVal) {
      if (this.isMultipuleSelect) {
        // 多选模式下确保 selected 是数组
        if (Array.isArray(newVal)) {
          this.selected = newVal;
        } else if (typeof newVal === 'string' && newVal) {
          this.selected = newVal.split(',');
        } else {
          this.selected = [];
        }
      } else {
        this.selected = newVal;
      }
    },
  },
  created() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      const key = dataKeyMap[this.code];
      const stateValues = this.$store.state.system.dictionaryValues;
      const initSelected = (val) => {
        if (this.isMultipuleSelect) {
          if (Array.isArray(val)) return val;
          if (typeof val === 'string' && val) return val.split(',');
          return [];
        }
        return val;
      };
      if (stateValues[key] && stateValues[key].length) {
        this.dataList = stateValues[key];
        this.selected = initSelected(this.defaultVal);
        return;
      }
      getKeyValues([key]).then((res) => {
        this.dataList = res.data[key].children;
        this.selected = initSelected(this.defaultVal);
      });
    },
    handleChangeOrgans(data) {
      // console.log("data", data);
    },
    changeCascader() {
      let data = [];
      const selectedNode = this.$refs.cascader.getCheckedNodes()[0];
      if (selectedNode) {
        data = [];
      }
      this.$emit("change", data);
    },
    changeSelect(val) {
      if (!this.isMultipuleSelect) {
        let selected = this.dataList.find(v => v.code == val);
        this.$emit('change', selected || {});
      } else {
        const nameArr = [];
        val.forEach((item) => {
          const selectItm = this.dataList.find((v) => v.code == item);
          nameArr.push(selectItm);
        });
        this.$emit("change", { nameList: nameArr, codeList: val } || {});
      }
    },

    get( arr){
      arr.forEach(item => {
        if(item.children.length){
          this.get(item.children);
        }else{
          this.list.push(item);
        }
      });

    }
  },
};
</script>
<style lang="scss">
.select-from-dictionary {
  display: inline-block;
}
</style>
